// Generated by scripts/generate-field-owners.mjs — do not edit.
// Top-level Query/Mutation fields mapped to their @owner(team:) directive
// in the savannah-gateway public schemas.
export type BackendTeam = "bizx" | "connectors" | "platform" | "prodexp";

export const FIELD_OWNERS: Record<string, BackendTeam> = {
  activityLog: "prodexp",
  addCompressionPolicy: "prodexp",
  addMfaMethod: "bizx",
  addSupportCaseReply: "prodexp",
  approveDeviceAuthorization: "bizx",
  attachServiceToGenericExporter: "platform",
  attachServiceToMetricExporter: "platform",
  attachServiceToPrivateLinkConnection: "platform",
  attachServiceToVpc: "platform",
  backupsRetentionStatus: "platform",
  billingTimeline: "bizx",
  bindIPAllowList: "platform",
  cancelCurrentQuery: "prodexp",
  cancelPendingPaymentDeletion: "bizx",
  cancelProjectInvite: "bizx",
  changePassword: "bizx",
  chargeInvoice: "bizx",
  claimPrivateLinkConnection: "platform",
  closeSupportCase: "prodexp",
  configureIPAllowList: "platform",
  connectors: "connectors",
  createBillingEmailAddress: "bizx",
  createCardVerificationCharge: "bizx",
  createFileImport: "connectors",
  createGenericExporter: "platform",
  createIcebergSync: "connectors",
  createKafkaClusterConfig: "connectors",
  createKafkaConnector: "connectors",
  createMetricExporter: "platform",
  createOrganizationProject: "bizx",
  createPATRecord: "bizx",
  createPaymentMethod: "bizx",
  createProject: "bizx",
  createProjectSecret: "platform",
  createS3LiveSync: "connectors",
  createSchema: "connectors",
  createSchemaRegistryConfig: "connectors",
  createService: "platform",
  createSupportTicket: "bizx",
  createUIState: "platform",
  createUser: "bizx",
  createVpc: "platform",
  crossRegionBackupsStatus: "platform",
  crossRegionBackupsStatusV2: "platform",
  dbagent: "prodexp",
  declineProjectInvite: "bizx",
  deleteAllCustomerData: "bizx",
  deleteBillingEmailAddress: "bizx",
  deleteCompressionPolicy: "prodexp",
  deleteGenericExporter: "platform",
  deleteMetricExporter: "platform",
  deleteMfaMethod: "bizx",
  deletePATRecord: "bizx",
  deletePaymentMethod: "bizx",
  deletePeeringConnection: "platform",
  deletePrivateLinkConnection: "platform",
  deleteProjectSecret: "platform",
  deleteS3LiveSync: "connectors",
  deleteService: "platform",
  deleteUIState: "platform",
  deleteVpc: "platform",
  detachServiceFromGenericExporter: "platform",
  detachServiceFromMetricExporter: "platform",
  detachServiceFromPrivateLinkConnection: "platform",
  detachServiceFromVpc: "platform",
  disableProject: "bizx",
  disableStaticResources: "platform",
  disableUser: "bizx",
  dismissRecommendation: "prodexp",
  dismissRecommendationV2: "prodexp",
  downgradeCheck: "bizx",
  explorer: "prodexp",
  generatePresignedURL: "connectors",
  getAllGenericExporters: "platform",
  getAllMetricExporters: "platform",
  getAllNextMaintenance: "platform",
  getAllOrganizationsForUser: "bizx",
  getAllProjects: "bizx",
  getAllServices: "platform",
  getAllServicesStorageThresholdEvents: "platform",
  getAllVpcs: "platform",
  getBillingEmailAddresses: "bizx",
  getCatalogTableList: "prodexp",
  getCompressionRecommendationsForOrderBy: "prodexp",
  getCompressionRecommendationsForSegmentBy: "prodexp",
  getConnector: "connectors",
  getConnectors: "connectors",
  getContAggInfo: "prodexp",
  getContAggList: "prodexp",
  GetContAggListV2: "prodexp",
  getCostedProjectDataTieringUsageDistribution: "bizx",
  getCurrentCost: "bizx",
  getCurrentPATRecord: "bizx",
  getDatabaseOverview: "prodexp",
  getDataTieringSummary: "platform",
  getFileImport: "connectors",
  getGenericExporter: "platform",
  getGhostProjectStatus: "platform",
  getImportState: "connectors",
  getInvoicing: "bizx",
  getIPAllowLists: "platform",
  getJWTForClientCredentials: "bizx",
  getKafkaSrcConnectorStatus: "connectors",
  getKafkaTopicSchemaMapping: "connectors",
  getKafkaTopicsFromCluster: "connectors",
  getLargestObjects: "prodexp",
  getLastServiceResourceMetrics: "platform",
  getMetricExporter: "platform",
  getMonthRemainderEstimate: "bizx",
  getNextMaintenance: "platform",
  getObjectsMetadata: "prodexp",
  getOrbInvoices: "bizx",
  getOrganizationMembers: "bizx",
  getPATRecords: "bizx",
  getPaymentMethods: "bizx",
  getPendingPaymentDeletion: "bizx",
  getPopSQLIntegrationStatus: "platform",
  getPostgresAndTimescaleDBVersion: "platform",
  getPostgresAvailableExtensions: "prodexp",
  getPostgresMajorVersionUpgradeStatus: "platform",
  getPostgresParameters: "platform",
  getPrivateLinkServiceConnections: "platform",
  getProject: "bizx",
  getProjectInvites: "bizx",
  getProjectInvitesForUser: "bizx",
  getProjectMembers: "bizx",
  getProjectSecrets: "platform",
  getQueryDetails: "prodexp",
  getQueryLatestExplain: "prodexp",
  getQueryMetricGraphs: "prodexp",
  getQueryStatsAndMetadata: "prodexp",
  getRecommendations: "prodexp",
  getRecoveryProgress: "platform",
  getRecoveryWindows: "platform",
  getS3LiveSync: "connectors",
  getS3LiveSyncAudit: "connectors",
  getS3LiveSyncRuntimeAudit: "connectors",
  getS3LiveSyncStatistics: "connectors",
  getService: "platform",
  getServiceConfigHistory: "platform",
  getServiceDeploymentStatus: "platform",
  getServiceLogs: "prodexp",
  getServiceMetrics: "platform",
  getServiceResourceMetrics: "platform",
  getServiceStorageThresholdEvent: "platform",
  getSupportCases: "prodexp",
  getTableInfo: "prodexp",
  getTableList: "prodexp",
  getTimescaleVersion: "prodexp",
  getUIState: "platform",
  getUser: "bizx",
  getVirtualPlans: "bizx",
  getVpc: "platform",
  getVpcByName: "platform",
  hasBackups: "platform",
  icebergSyncInfo: "connectors",
  inviteProjectMember: "bizx",
  joinProject: "bizx",
  leaveProject: "bizx",
  linkMarketplaceAccount: "bizx",
  listBackups: "platform",
  listBucketObjects: "connectors",
  listFileImport: "connectors",
  listForkRegions: "platform",
  listPrivateLinkAvailableRegions: "platform",
  listPrivateLinkBindings: "platform",
  listPrivateLinkConnections: "platform",
  listS3LiveSync: "connectors",
  loginMfa: "bizx",
  logout: "bizx",
  mfaChallenge: "bizx",
  newFileImport: "connectors",
  openPeerRequest: "platform",
  orbAllProducts: "bizx",
  orbProducts: "bizx",
  previewSource: "connectors",
  processFileImport: "connectors",
  regenerateRecoveryCodes: "bizx",
  renamePATRecord: "bizx",
  renameProject: "bizx",
  renameService: "bizx",
  renameVpc: "platform",
  requestAuthorizationCode: "bizx",
  resendInviteProjectMember: "bizx",
  resendVerifyBillingEmailAddress: "bizx",
  resendVerifyEmail: "bizx",
  resetPassword: "bizx",
  resetPostgresParameters: "platform",
  resetServicePassword: "platform",
  resizeInstance: "platform",
  retryS3LiveSyncFileImports: "connectors",
  revokeOtherSessions: "bizx",
  revokeProjectMember: "bizx",
  revokeRefreshToken: "bizx",
  revokeSession: "bizx",
  sendPasswordReset: "bizx",
  sendSupportEmail: "bizx",
  serviceLogs: "prodexp",
  setAddressInfo: "bizx",
  setBackupsRetention: "platform",
  setCompression: "prodexp",
  setCompressionHypertable: "prodexp",
  setHypertableConf: "prodexp",
  setMaintenanceWindow: "platform",
  setPostgresParameters: "platform",
  setPrimaryPaymentMethod: "bizx",
  setProjectEnforcementType: "bizx",
  setReplicaCount: "platform",
  setServiceEnvironmentTag: "platform",
  setVirtualPlanForProject: "bizx",
  skipFileImport: "connectors",
  syncPrivateLinkConnections: "platform",
  toggleChunkTuning: "prodexp",
  toggleConnectionPooler: "platform",
  toggleCrossRegionBackups: "platform",
  toggleCrossRegionBackupsV2: "platform",
  toggleDataTiering: "platform",
  toggleIOBoost: "platform",
  togglePopSQLIntegration: "platform",
  toggleService: "platform",
  toggleServiceChunkTuning: "prodexp",
  transferOwnership: "bizx",
  transferProjectOwnership: "bizx",
  unbindIPAllowList: "platform",
  unskipFileImport: "connectors",
  updateConnector: "connectors",
  updateFileImport: "connectors",
  updateGenericExporter: "platform",
  updateMetricExporter: "platform",
  updateOrganizationName: "bizx",
  updatePaymentMethod: "bizx",
  updatePeeringConnectionCIDRs: "platform",
  updatePrivateLinkConnection: "platform",
  updateProjectSecret: "platform",
  updateS3LiveSync: "connectors",
  updateTaxID: "bizx",
  updateUIState: "platform",
  updateUser: "bizx",
  updateUserRole: "bizx",
  upgradePostgresMajorVersion: "platform",
  userSessions: "bizx",
  validateAddress: "bizx",
  validateConnectorSpecIceberg: "connectors",
  validateResetToken: "bizx",
  validateResetTokenMfa: "bizx",
  verifyBillingEmailAddress: "bizx",
  verifyEmail: "bizx",
};
